<template>
  <div class="product">
    <headers></headers>
    <div class="product-info1">
      <img src="../assets/images/product/product1.png" alt />
    </div>
    <div class="product-info2">网页后台管理端</div>
    <div class="product-info3">老板/员工使用</div>

    <el-row class="feature-content">
      <el-col :span="24" style="display: flex;justify-content: center;">
        <div class="bigbox-left">
          <div class="boxs">
            <p>
              <img src="../assets/images/product/product3.png" alt width="60px" />
            </p>
            <p style="font-size: 24px; margin: 14px 0 20px 0;">店铺管理</p>
            <p style="font-size: 20px;color:#666;">
              订货单/销售单/调货单/退货单/维修
              <br />单/报损单…不同单据分类管理。
            </p>
          </div>
          <div class="boxs">
            <p>
              <img src="../assets/images/product/product4.png" alt width="50px" />
            </p>
            <p style="font-size: 24px; margin:  14px 0 20px 0;">订单管理</p>
            <p style="font-size: 20px;color:#666;">
              商品检测完成后，加工中心根据加工
              <br />要求加工工艺进行加工。
            </p>
          </div>
        </div>

        <div class="boxs_z">&nbsp;</div>

        <div class="bigbox-right">
          <div class="boxs">
            <p>
              <img src="../assets/images/product/product5.png" alt width="50px" />
            </p>
            <p style="font-size: 24px; margin:  14px 0 20px 0;">商品管理</p>
            <p style="font-size: 20px;color:#666;">
              商品分类管理，excel表格导入/导出
              <br />商品库存提醒，保证门店经营无困扰。
            </p>
          </div>
          <div class="boxs">
            <p>
              <img src="../assets/images/product/product2.png" alt width="50px" />
            </p>
            <p style="font-size: 24px; margin:  14px 0 20px 0;">报表管理</p>
            <p style="font-size: 20px;color:#666;">
              专业报表管理，全面数据报表显示门店
              <br />经营状况；大数据分析，精准定位门店 经营趋势。
            </p>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 移动端 -->
      <div class="smallfeature">
        <ul>
          <li>
            <p>
              <img src="../assets/images/product/product3.png" alt />
              <span>店铺管理</span>
            </p>
            <p>订货单/销售单/调货单/退货单/维修单/报损单…不同单据分类管理。</p>
          </li>
          <li>
            <p>
              <img src="../assets/images/product/product4.png" alt />
              <span>订单管理</span>
            </p>
            <p> 商品检测完成后，加工中心根据加工要求加工工艺进行加工。</p>
          </li>
          <li>
            <p>
              <img src="../assets/images/product/product5.png" alt />
              <span>商品管理</span>
            </p>
            <p>商品分类管理，excel表格导入/导出商品库存提醒，保证门店经营无困扰。</p>
          </li>
          <li>
            <p>
              <img src="../assets/images/product/product2.png" alt />
              <span>报表管理</span>
            </p>
            <p>专业报表管理，全面数据报表显示门店经营状况；大数据分析，精准定位门店 经营趋势。</p>
          </li>
        </ul>
      </div>

    <footers style="margin-top:50px;"></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import header from "../components/headers";

export default {
  name: "",
  components: {
    footers: footer,
    headers: header
  },
  data() {
    return {};
  },

  methods: {},
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
.product {
  width: 100%;
     @media screen and (max-width: 850px) {
      .feature-top {
        display: none;
      }
      .feature_top {
        display: block;
      }
      .feature-content {
        display: none;
      }
      .smallfeature {
        display: block;
      }
    }
    @media screen and (min-width: 850px) {
      .feature-top {
        display: block;
      }
      .feature_top {
        display: none;
      }
      .feature-content {
        display: block;
      }
      .smallfeature {
        display: none;
      }
    }
    .feature_top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .feature-top {
      margin: 80px 0;
      text-align: center;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
      }
      p {
        font-size: 18px;
      }
    }
    .bigbox-left {
      float: left;
      width: 440px;
      margin-right: 47px;
    }
    .bigbox-right {
      float: left;
      width: 440px;
    }
    .boxs {
      float: left;
      padding: 30px 40px;
      cursor: pointer;
      margin-bottom: 50px;
      width: 440px;
      border-radius: 4px;
      &:hover {
        transform: translate(-5px, -5px);
        transition: all 1s;
        box-shadow: 0px 0px 15px #d2e8ff;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .boxs_z {
      width: 1px;
      height: 520px;
      background-color: #d2d2d2;
      float: left;
      margin-right: 57px;
    }
    // 移动端
    .smallfeature {
      padding: 15px;
      ul {
        overflow: hidden;
        padding: 0 40px;
        li {
          margin-bottom: 40px;
          p {
            font-size: 12px;
            vertical-align: middle;
            img {
              width: 37px;
              vertical-align: middle;
            }
            span {
              font-weight: 600;
              margin-left: 10px;
            }
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
        }
      }
    }
  .product-info1 {
    width: 100%;
    // height:470px;
    margin-bottom: 60px;
    @media screen and (max-width: 850px) {
     margin-bottom: 30px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product-info2 {
    width: 20%;
    font-size: 28px;
    font-family: MicrosoftYaHei;
    // font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 20px;
    @media screen and (max-width: 850px) {
      width: 100%;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
  .product-info3 {
    width: 20%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    // font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 70px;
    @media screen and (max-width: 850px) {
      width: 100%;
      font-size: 12px;
      margin-bottom: 30px;
    }
  }
}
</style>
